"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tokenSchema = {
    id: '/Token',
    properties: {
        name: { type: 'string' },
        symbol: { type: 'string' },
        decimals: { type: 'number' },
        address: { $ref: '/Address' },
    },
    required: ['name', 'symbol', 'decimals', 'address'],
    type: 'object',
};
//# sourceMappingURL=token_schema.js.map